// Design System - Responsive Utilities
// Inspired by React Native responsive design patterns

import { breakpoints } from '../constants';

export const media = {
    mobile: `@media (max-width: ${breakpoints.mobileTablet}px)`,
    tablet: `@media (min-width: ${
        breakpoints.mobileTablet + 1
    }px) and (max-width: ${breakpoints.tabletDesktop}px)`,
    desktop: `@media (min-width: ${breakpoints.tabletDesktop + 1}px)`
};

// Responsive text alignment helper
export const getTextAlign = (desktop = 'left', mobile = 'center') => `
    text-align: ${desktop};
    
    ${media.mobile} {
        text-align: ${mobile};
    }
`;
